import { render, staticRenderFns } from "./comp-ikhtisar.vue?vue&type=template&id=034125cc&scoped=true&"
import script from "./comp-ikhtisar.vue?vue&type=script&lang=js&"
export * from "./comp-ikhtisar.vue?vue&type=script&lang=js&"
import style0 from "./comp-ikhtisar.vue?vue&type=style&index=0&id=034125cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034125cc",
  null
  
)

export default component.exports